import React from 'react';
import css from './SideNavItem.module.css';
import { NamedLink } from '../../../../components';
const SideNavItem = props => {
  const { label, namedLinkProps = { name: 'LandingPage' }, isSelected, disabled } = props;

  if (disabled) {
    return (
      <span className={css.wrapperDisabled}>
        {' '}
        {label}
        {/* <span className={css.commingSoon}>{'(Comming soon)'}</span> */}
      </span>
    );
  }
  return (
    <div className={css.buttonContanier}>
      <NamedLink {...namedLinkProps} className={isSelected ? css.selectedWrapper : css.wrapper}>
        {label}
      </NamedLink>
    </div>
  );
};

export default SideNavItem;
